import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
  } from "./dialog";
  
type ModalPropsType =  {
    title?: React.ReactNode;
    description?: React.ReactNode;
    footer?: React.ReactNode;
    children: React.ReactNode;
    open: boolean;
    handleClose: Function;
    showCloseButton?: boolean;
  }
  
  export const Modal = ({
    title,
    description,
    footer,
    children,
    open,
    handleClose,
    showCloseButton = false,
    ...props
  }: ModalPropsType) => {
    return (
      <Dialog {...props} open={open} onOpenChange={(isOpen) => !isOpen && handleClose()}>
        <DialogContent className="sm:max-w-[425px] bg-white" showCloseButton={showCloseButton}>
          <DialogHeader>
            {title && <DialogTitle>{title}</DialogTitle>}
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
          {children}
          {footer && <DialogFooter>{footer}</DialogFooter>}
        </DialogContent>
      </Dialog>
    );
  };
  

  